import { Column, Columns, Container } from '@codeparva/ui-components-library';
import React from 'react';
import { weakKey } from '../../../../utilities/weakKey';
import { StepsFormSectionTypes } from './stepsTypes';
import { CircularProgressbar } from 'react-circular-progressbar';
import { StepsConstants } from './constants';

export const StepsComponent = ({
  activeStep,
  childrenArray,
  completed,
  formType = 'Rental',
}: StepsFormSectionTypes.ISteps) => {
  const percentage = StepsConstants.totalPercent / childrenArray.length;
  const StepsLabel = ({ children }: any) => {
    return (
      <div className="steps-content mt-4">
        <p className="is-size-6">{children?.props.label}</p>
      </div>
    );
  };

  return (
    <>
      <p className="stepsContainerTitle is-hidden-tablet">{formType}</p>
      <Container className="stepsContainer mb-0">
        <div className="stepsDiv is-hidden-mobile">
          <ul className="steps has-content-centered is-thin is-large">
            {childrenArray.map((child, index: number) => {
              return completed ? (
                <li
                  className={`steps-segment has-text-primary ${index ===
                    childrenArray.length - 1 && 'is-active'}`}
                  key={weakKey({ child })}
                >
                  <span className={`steps-marker p-2`}>
                    <p className="stepNumber ">{index + 1}</p>
                  </span>
                  <StepsLabel children={child} />
                </li>
              ) : (
                <li
                  className={`steps-segment ${activeStep === index &&
                    'is-active has-text-primary'}`}
                  data-cy={
                    activeStep === index && `isCurrentActiveStep-${index}`
                  }
                  key={weakKey({ child })}
                >
                  <span
                    className={`steps-marker p-2 ${activeStep === index &&
                      'is-hollow has-text-primary'}`}
                  >
                    <p className="stepNumber">{index + 1}</p>
                  </span>
                  <StepsLabel children={child} />
                </li>
              );
            })}
          </ul>
        </div>
        <div className="circularProgressDiv is-hidden-tablet">
          <CircularProgressbar
            value={(activeStep + 1) * percentage}
            text={`${activeStep + 1} of ${childrenArray.length}`}
            styles={{
              text: {
                alignmentBaseline: 'middle',
              },
            }}
          />
          <Columns marginless multiline className="circularTextDiv">
            <Column className="circularColumnOne">
              {childrenArray.map((child, index: number) => {
                return (
                  <h3 className="titles" key={weakKey(child)}>
                    {index === activeStep && child?.props?.label}
                  </h3>
                );
              })}
            </Column>
            <Column className="circularColumnTwo">
              <p className="nextPara">
                {activeStep !== childrenArray.length - 1
                  ? `Next: ${childrenArray[activeStep + 1]?.props.label}`
                  : ''}
              </p>
            </Column>
          </Columns>
        </div>
      </Container>
    </>
  );
};
